import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Toast } from 'antd-mobile';
import { useTranslation } from '@/i18n';
import config from '@/config';
import { getTodayData } from '@/api/airportTransfer';
import { createNonceStr, md5, getLocationSearch } from '../../utils/utils';

import './index.scss';

const Home = () => {
  const t = useTranslation();
  const [userInfo, setUserInfo] = useState({});
  const [todayData, setTodayData] = useState({
    completeOrder: 0,
    inCome: 0,
    untreatedOrder: 0
  });
  const history = useHistory();

  useEffect(() => {
    document.title = t('home.pageTitle');
    // 设置页面标题（如果在 WebView 中）
    if (typeof window?.savePicture?.setTitle === 'function') {
      window?.savePicture?.setTitle(t('home.pageTitle'));
    }

    // 检查登录状态
    const token = getLocationSearch().token|| localStorage.getItem("userToken") || "";
    const driverDetail = localStorage.getItem('driverDetail');
    if (!token) {
      // 如果没有登录，跳转到登录页
      history.replace('/login');
      return;
    }

    // 获取今日数据
    fetchTodayData();
    if(driverDetail){
        setUserInfo(JSON.parse(driverDetail));
    }
  }, [history]);


  // 获取今日数据
  const fetchTodayData = async () => {
    try {
      const response = await getTodayData();
      if (response?.data?.code === 200) {
        setTodayData(response.data.data);
      }else if (response?.data?.errorCode === 110004){
        Toast.fail(t('home.loginRequired'), 2)
        // 如果没有登录，跳转到登录页
        history.replace('/login');
        return;
      }else {
        console.error('获取今日数据失败', response?.data?.errorMsg);
      }
    } catch (error) {
      console.error('获取今日数据失败', error);
    }
  };

  // 跳转到抢单大厅
  const goToOrderHall = () => {
    history.push('/airportTransfer/hall');
  };

  // 跳转到接单记录
  const goToOrderRecord = () => {
    history.push('/airportTransfer/record');
  };

  // 跳转到司机钱包
  const goToWallet = () => {
    history.push('/wallet');
  };

  // 跳转到扬招单
  const goToBeckonOrder = () => {
    history.push('/beckonOrder');
  };

  // 跳转到订单历史
  const goToOrderHistory = () => {
    Toast.info(t('home.orderHistory'), 1);
    // history.push('/order/history');
  };

  // 跳转到客服中心
  const goToService = () => {
    Toast.info(t('home.customerService'), 1);
    // history.push('/service');
  };

  // 跳转到设置
  const goToSettings = () => {
    history.push('/setting');
  };

  // 跳转到消息中心
  const goToMessageCenter = () => {
    history.push('/messageCenter');
  };

  // 跳转到电话订单
  const goToCallOrder = () => {
    history.push('/callOrder');
  };

  // 退出登录
  const handleLogout = () => {
    localStorage.removeItem('userToken');
    Toast.success(t('home.logoutSuccess'), 1);
    setTimeout(() => {
      history.replace('/login');
    }, 1000);
  };

  return (
    <div className="home-container">
      {/* 重构后的顶部渐变头部 */}
      <div className="home-header">
         {/* <div className="service-title">
          <h1>接机 · 送机 · 包车服务</h1>
        </div> */}
        <div className="header-content">
          <div className="user-avatar-wrapper">
            <div className="user-avatar">
              <i className="iconfont icon-user"></i>
            </div>
            <div className="user-greeting">
              <p className="greeting-text">{t('home.greeting', { name: userInfo.driverName || t('home.defaultDriver') })}</p>
              <div className="status-badge">
                <span className="status-dot"></span>
                <span className="status-text">{t('home.onlineStatus')}</span>
              </div>
            </div>
          </div>
          <div className="header-actions">
            <div className="message-icon-wrapper" onClick={goToMessageCenter}>
              <i className="iconfont icon-message"></i>
              {todayData.untreatedOrder > 0 && (
                <span className="message-badge">{todayData.untreatedOrder}</span>
              )}
            </div>
          </div>
        </div>
       
      </div>

      <div className="home-content">
        {/* 重构后的数据统计卡片 */}
        <div className="stats-cards">
          <div className="stat-card stat-card-primary">
            <div className="stat-icon">
              <i className="iconfont icon-order"></i>
            </div>
            <div className="stat-info">
              <div className="stat-value">{todayData.completeOrder}</div>
              <div className="stat-label">{t('home.completedOrders')}</div>
            </div>
          </div>
          <div className="stat-card stat-card-success">
            <div className="stat-icon">
              <i className="iconfont icon-wallet"></i>
            </div>
            <div className="stat-info">
              <div className="stat-value">¥{(todayData.inCome/100).toFixed(2)}</div>
              <div className="stat-label">{t('home.todayIncome')}</div>
            </div>
          </div>
          <div className="stat-card stat-card-warning" onClick={goToOrderRecord}>
            <div className="stat-icon">
              <i className="iconfont icon-history"></i>
            </div>
            <div className="stat-info">
              <div className="stat-value">{todayData.untreatedOrder}</div>
              <div className="stat-label">{t('home.pendingOrders')}</div>
            </div>
            {todayData.untreatedOrder > 0 && <div className="stat-badge">!</div>}
          </div>
        </div>

        {/* 重构后的功能菜单网格 */}
        <div className="function-section">
          <div className="section-header">
            <h2>{t('home.quickFunctions')}</h2>
            <p>{t('home.selectService')}</p>
          </div>
          
          <div className="function-grid">
            <div className="function-card function-card-blue" onClick={goToOrderHall}>
              <div className="card-icon-wrapper">
                <div className="card-icon">
                  <i className="iconfont icon-order"></i>
                </div>
              </div>
              <h3 className="card-title">{t('home.orderHall')}</h3>
              <p className="card-desc">{t('home.realTimeOrders')}</p>
              <div className="card-arrow">
                <i className="iconfont icon-arrow-right"></i>
              </div>
            </div>
              <div className="function-card function-card-green" onClick={goToCallOrder}>
              <div className="card-icon-wrapper">
                <div className="card-icon">
                  <i className="iconfont icon-phone"></i>
                </div>
              </div>
              <h3 className="card-title">{t('home.phoneOrders')}</h3>
              <p className="card-desc">{t('home.appointmentManagement')}</p>
              <div className="card-arrow">
                <i className="iconfont icon-arrow-right"></i>
              </div>
            </div>

            <div className="function-card function-card-orange" onClick={goToBeckonOrder}>
              <div className="card-icon-wrapper">
                <div className="card-icon">
                  <i className="iconfont icon-order"></i>
                </div>
              </div>
              <h3 className="card-title">{t('home.beckonOrder')}</h3>
              <p className="card-desc">{t('home.beckonOrderDesc')}</p>
              <div className="card-arrow">
                <i className="iconfont icon-arrow-right"></i>
              </div>
            </div>

            {/* <div className="function-card function-card-purple" onClick={goToMessageCenter}>
              <div className="card-icon-wrapper">
                <div className="card-icon">
                  <i className="iconfont icon-message"></i>
                </div>
              </div>
              <h3 className="card-title">消息中心</h3>
              <p className="card-desc">查看乘客消息</p>
              <div className="card-arrow">
                <i className="iconfont icon-arrow-right"></i>
              </div>
            </div> */}

          

            <div className="function-card function-card-red" onClick={goToOrderRecord}>
              <div className="card-icon-wrapper">
                <div className="card-icon">
                  <i className="iconfont icon-list"></i>
                </div>
              </div>
              <h3 className="card-title">{t('home.orderRecords')}</h3>
              <p className="card-desc">{t('home.recordManagement')}</p>
              <div className="card-arrow">
                <i className="iconfont icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="home-footer">
        <p>{t('home.contactService', { tel: config.TEL })}</p>
      </div>
    </div>
  );
};

export default Home;